/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_Point_0_TextInputs */

const en_visa_l1_point_0_text = /** @type {(inputs: Visa_L1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We confirm the qualifying relationship between the foreign and U.S. entities and review whether the business setup supports the intended filing.`)
};

const pt_visa_l1_point_0_text = /** @type {(inputs: Visa_L1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmamos a relação societária exigida entre as entidades estrangeira e norte-americana e verificamos se a estrutura do negócio respalda a apresentação pretendida.`)
};

const es_visa_l1_point_0_text = /** @type {(inputs: Visa_L1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmamos la relación societaria exigida entre las entidades extranjera y estadounidense y revisamos si la estructura empresarial respalda la solicitud prevista.`)
};

/**
* | output |
* | --- |
* | "We confirm the qualifying relationship between the foreign and U.S. entities and review whether the business setup supports the intended filing." |
*
* @param {Visa_L1_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_point_0_text = /** @type {((inputs?: Visa_L1_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_point_0_text(inputs)
	if (locale === "es") return es_visa_l1_point_0_text(inputs)
	return en_visa_l1_point_0_text(inputs)
});